











import Vue from "vue";
import {Component} from "vue-property-decorator";
// @ts-ignore
import store from "../../store";
@Component({
    components: {},
    props: {}
})

export default class CustomGameButton extends Vue {
    /**
     * Является ли игрок гостем
     * @private
     */
    private get isGuest(): boolean
    {
        return store.getters.getPlayerConnectionStatus === 'guest';
    }

    private selectCustomGame(): void
    {
        if (this.isGuest) {
            return;
        }
        this.$emit('select-custom-game');
    }
}
